export default {
  path: "/partner",
  component: {
    template: `<router-view></router-view>`
  },
  children: [
    {
      path: "users",
      component: () => import("@/components/Partner/Users")
    },
    {
      path: "add-user",
      component: () => import("@/components/Partner/AddUser")
    },
    {
      path: "report",
      component: ()=> import("@/components/Partner/Report")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/partner.js